// Shared accent-color palette (Tailwind bg-* classes) for training content:
// module colors (ModuleEditorModal) and badge colors (BadgeEditorModal).
// One list so the swatches never diverge between pickers - a class removed
// here may still be stored on existing rows, so prefer adding over renaming.
export const COLOR_OPTIONS = [
  { name: "Gray", value: "bg-slate-400" },
  { name: "Purple", value: "bg-violet-600" },
  { name: "Blue", value: "bg-sky-700" },
  { name: "Cyan", value: "bg-cyan-600" },
  { name: "Green", value: "bg-emerald-600" },
  { name: "Lime", value: "bg-lime-600" },
  { name: "Yellow", value: "bg-amber-500" },
  { name: "Orange", value: "bg-orange-600" },
  { name: "Red", value: "bg-red-600" },
  { name: "Pink", value: "bg-pink-600" },
];
